// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


/* table sticky */

.table-container{
  /* max-height:600px; */
  overflow-y: auto;
}

.mis-table thead th{
  position: sticky;
  top:0;
  z-index:2;
  border: 1px solid #000;
}

.mis-table thead tr:nth-child(2) th{
  top:40px;
}

.sticky-col{
  position: sticky;
  left:0;
  background:white;
  z-index:3;
}

.mis-table table tbody td{
  white-space:nowrap;
}


table {
  width: 100%;
  table-layout: fixed;
  /* border-collapse: separate; */
  border-collapse: collapse !important;
  /* border: 2px solid black; */
}

td, th {
  border: 2px solid black;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.shaded-row td {
  background-color: #e9ecef !important;
}

.privilege-modal {
    max-width: 1000px !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA,iBAAiB;;AAEjB;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,KAAK;EACL,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n/* table sticky */\n\n.table-container{\n  /* max-height:600px; */\n  overflow-y: auto;\n}\n\n.mis-table thead th{\n  position: sticky;\n  top:0;\n  z-index:2;\n  border: 1px solid #000;\n}\n\n.mis-table thead tr:nth-child(2) th{\n  top:40px;\n}\n\n.sticky-col{\n  position: sticky;\n  left:0;\n  background:white;\n  z-index:3;\n}\n\n.mis-table table tbody td{\n  white-space:nowrap;\n}\n\n\ntable {\n  width: 100%;\n  table-layout: fixed;\n  /* border-collapse: separate; */\n  border-collapse: collapse !important;\n  /* border: 2px solid black; */\n}\n\ntd, th {\n  border: 2px solid black;\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.shaded-row td {\n  background-color: #e9ecef !important;\n}\n\n.privilege-modal {\n    max-width: 1000px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
